<script>
import api from '@/api';

export default {

  async created() {
    window.location.href = await api.token.sso();
  },
};
</script>
